import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SCHEDULE_CTA_BY_NAME } from 'constants/schedule-ctas';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { ReserveCta } from './cta/ReserveCta';
import { CancelCta } from './cta/CancelCta';
import { BuyCta } from './cta/BuyCta';
import { SignUpCta } from './cta/SignUpCta';
import { ReactivateCta } from './cta/ReactivateCta';
import { JoinCta } from './cta/JoinCta';
import { DisableCta } from './cta/DisableCta';
import { handleScheduleAction, watchScheduleCtaSagas } from './ScheduleCta.saga';

export class ScheduleCtaUnwrapped extends PureComponent {
  components = {
    [SCHEDULE_CTA_BY_NAME.buy]: BuyCta,
    [SCHEDULE_CTA_BY_NAME.cancel]: CancelCta,
    [SCHEDULE_CTA_BY_NAME.disable]: DisableCta,
    [SCHEDULE_CTA_BY_NAME.join]: JoinCta,
    [SCHEDULE_CTA_BY_NAME.reactivate]: ReactivateCta,
    [SCHEDULE_CTA_BY_NAME.reserve]: ReserveCta,
    [SCHEDULE_CTA_BY_NAME.signup]: SignUpCta,
  };

  handleClick = event => {
    const { onClick, schedule } = this.props;

    if (onClick) {
      onClick(event);
    }

    this.props.handleScheduleAction(schedule);
  };

  render() {
    const { action, ...props } = this.props;
    if (!action) {
      return null;
    }

    const Component = this.components[action];
    return <Component {...props} onClick={this.handleClick} />;
  }
}

ScheduleCtaUnwrapped.propTypes = {
  action: PropTypes.oneOf(Object.values(SCHEDULE_CTA_BY_NAME)),
  handleScheduleAction: PropTypes.func.isRequired,
  ScheduleCta: PropTypes.bool,
  onClick: PropTypes.func,
  schedule: PropTypes.object,
};

export const ScheduleCta = decorateWith(
  connect(
    null,
    { handleScheduleAction }
  ),
  withSagas({ watch: watchScheduleCtaSagas }),
  withName('ScheduleCta')
)(ScheduleCtaUnwrapped);
